import { ComplainantActa } from "../Model/ComplainantActa";
import { Query } from "../Model/Query";
import { Third } from "../Model/Third";
import { getCurrentUser } from "./session";
import { v4 as v4uuid } from "uuid";
export class ComplainantActaService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOneByDiligenceNumber(ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('complainant_acta/acta/' + ndiligencia);
            if (!response.ok) {
                throw new Error(`Error al obtener la victima`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findOne(diligenceId, thirdId) {
        if (diligenceId && thirdId) {
            const response = await this.apiService.get('complainant_acta/acta/' + diligenceId + '/third_id/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener Id`);
        }
    }
    async saveComplainantActa(denounded) {
        if (denounded) {
            const response = await this.apiService.post('complainant_acta', denounded);
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de Acta.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener  Genero.`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`complainants_acta/actaThirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async createComplainantActa(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const third = new ComplainantActa({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                userId: getCurrentUser().id,
                lawId: null,
                articleId: null,
                complainantThirId: thirdId,
                intervenedMaterial: " "
            });
            const response = await this.apiService.post('complainant_acta', third.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia acta`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
    async deleteComplainantActa(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('complainants_acta/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el denunciante de una diligencia acta.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante.`);
        }
    }
}
